import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Link as RouterLink } from "react-router-dom";

// If you want to use a regular anchor tag for external links, use 'a' instead of RouterLink
const BookSessionButton = () => (
    <Box textAlign="center">
        <Button
            component="a"
            href="https://calendly.com/positive-psychology-sessions/30min?"
            target="_self"
            color="primary"
            sx={{
                bgcolor: "custom.blue",
                color: "text.primary",
                fontWeight: 700,
                fontSize: 20,
                px: 4,
                py: 1.5,
                marginTop: 5,
                borderRadius: 2,
                textTransform: "none",
                "&:hover": {
                    bgcolor: "primary.main",
                },
            }}
        >
            Book Your FREE Positive Psychology Session
        </Button>
    </Box>
);

export default BookSessionButton;